if (typeof Object.hasOwn !== 'function') {
  Object.defineProperty(Object, 'hasOwn', {
    value(target, propertyKey) {
      if (target == null) {
        throw new TypeError('Cannot convert undefined or null to object')
      }

      return Object.prototype.hasOwnProperty.call(Object(target), propertyKey)
    },
    configurable: true,
    writable: true
  })
}
